import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  isCheckoutSuccessPath,
  readCheckoutSessionIdFromLocation
} from '../utils/checkout-return.util';

/** Sends Stripe return links to the receipt route when session_id is present. */
export function redirectCheckoutReturnIfNeeded(): Promise<boolean | void> {
  const sessionId = readCheckoutSessionIdFromLocation();
  if (!sessionId || isCheckoutSuccessPath(window.location.pathname)) {
    return Promise.resolve();
  }

  const router = inject(Router);
  return router.navigate(['/checkout/success'], {
    queryParams: { session_id: sessionId },
    replaceUrl: true
  });
}
